import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// Layout
import Header from "../layout/header";
import Footer from "../layout/footer";

// Elements
import ServicesSection from "../elements/services-1";
import ChooseUsSection from "../elements/choose-us";

// API instead of JSON imports
import { getBrands, getModels, getZomatoPricing } from '../../utils/vehicleApi';

// The Zomato modal
import ZomatoRiderModal from '../elements/zomato-rider-modal';

import { getLocalItem } from '../../utils/storage';

class ZomatoRiderServices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vehicleType: 'bike',
      brand: '',
      model: '',
      ccRange: '',
      filteredBikeBrands: [],
      bikeModels: [],
      brandDropdownOpen: false,
      modelDropdownOpen: false,
      isMouseInsideDropdown: false,
      openZomatoModal: true,
      zomatoRider: null,
      currentServices: [],
    };

    this.EXCLUDED_BRANDS = ["Benelli", "BMW", "Ducati", "Harley Davidson", "Husqvarna", "Hyosung", "Kawasaki", "KTM", "Royal Enfield", "Triumph", "UM", "Yezdi"];
    this.top10BikeBrands = ['Hero', 'Honda', 'TVS', 'Bajaj', 'Royal Enfield', 'Yamaha', 'Suzuki', 'KTM', 'Jawa', 'BMW'];
  }

  customSortByPopularity(brandArray, top10List) {
    return brandArray.sort((a, b) => {
      const aIndex = top10List.indexOf(a.label);
      const bIndex = top10List.indexOf(b.label);
      if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
      if (aIndex !== -1) return -1;
      if (bIndex !== -1) return 1;
      return a.label.localeCompare(b.label);
    });
  }

  async componentDidMount() {
    try {
      const data = await getBrands('bike');
      let brands = (data.brands || []).filter(
        (brand) => !this.EXCLUDED_BRANDS.includes(brand.label)
      );
      brands = this.customSortByPopularity(brands, this.top10BikeBrands);
      this.setState({ filteredBikeBrands: brands });
    } catch (err) {
      // Fallback: empty brands
    }
  }

  handleMouseEnter = (dropdownName) => {
    Object.keys(this.state).forEach((key) => {
      if (key.endsWith('DropdownOpen') && key !== `${dropdownName}DropdownOpen`) {
        this.setState({ [key]: false });
      }
    });
    this.setState({ [`${dropdownName}DropdownOpen`]: true });
  };

  handleMouseLeave = (dropdownName) => {
    setTimeout(() => {
      if (!this.state.isMouseInsideDropdown) {
        this.setState({ [`${dropdownName}DropdownOpen`]: false });
      }
    }, 200);
  };

  handleDropdownOptionsMouseEnter = () => {
    this.setState({ isMouseInsideDropdown: true });
  };

  handleDropdownOptionsMouseLeave = () => {
    this.setState({ isMouseInsideDropdown: false });
  };

  setOpenZomatoModal = (val) => {
    this.setState({ openZomatoModal: val });
  };

  setZomatoRider = (riderObj) => {
    this.setState({ zomatoRider: riderObj });
  };

  handleBrandChange = async (brand) => {
    this.setState({ brand, model: '', ccRange: '', currentServices: [], bikeModels: [] });
    try {
      const data = await getModels(brand.value, 'bike');
      const models = (data.models || []).slice().sort((a, b) =>
        a.label.toLowerCase().localeCompare(b.label.toLowerCase())
      );
      this.setState({ bikeModels: models });
    } catch (err) {
      // Fallback: empty models
    }
  };

  handleDropdownClick = (key, value) => {
    this.setState({ [key]: value }, () => {
      if (key === 'ccRange') {
        this.fetchZomatoServices(value);
      }
    });
  };

  fetchZomatoServices = async (ccRange) => {
    try {
      const data = await getZomatoPricing(ccRange);
      const services = (data.services || []).map((svc) => ({
        ...svc,
        'strikethrough-price': svc.strikethrough_price || svc['strikethrough-price'],
      }));
      this.setState({ currentServices: services });
    } catch (err) {
      this.setState({ currentServices: [] });
    }
  };

  shouldDisplayServices = () => {
    const { brand, model, ccRange, currentServices } = this.state;
    return brand && model && ccRange && currentServices.length > 0;
  };

  render() {
    const {
      vehicleType, brand, model, ccRange, bikeModels,
      openZomatoModal, currentServices
    } = this.state;

    const { isMobileBrowser, isMobileApp, user, setUser, openModal } = this.props;
    const canonicalUrl = 'https://www.ridenrepair.com/zomato-rider-services';
    const ccRangesToShow = ['0-199cc', '200-249cc'];

    return (
      <>
        <Helmet>
          <link rel="canonical" href={canonicalUrl} />
          <title>Zomato Deliver Partner Bike Services - Ride N Repair</title>
          <meta name="description" content="Special discounted two-wheeler servicing for Zomato delivery partners. Avail your exclusive prices now!" />
        </Helmet>

        {!getLocalItem('zomato_id') &&
          <ZomatoRiderModal
            openZomatoModal={openZomatoModal}
            setOpenZomatoModal={this.setOpenZomatoModal}
            setZomatoRider={this.setZomatoRider}
            setOpenModal={this.props.setOpenModal}
          />
        }

        <Header isMobileBrowser={isMobileBrowser} isMobileApp={isMobileApp} user={user} setUser={setUser} />

        <div className="page-content bg-white">
          <div className="page-banner ovbl-dark vehicle-services-header" style={{ backgroundColor: 'black', overflow: 'visible' }}>
            <div className="container">
              <div className="page-banner-entry text-center">
                <h1><span>Zomato Deliver Partner Bike Services</span></h1>
                <nav aria-label="breadcrumb" className="breadcrumb-row">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/"><i className="las la-home"></i>Home</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Zomato Deliver Partner Bike Services
                    </li>
                  </ul>
                </nav>
                <h3 style={{ marginTop: '3%', color: 'white' }}>Choose Your Bike</h3>

                <div className="vehicle-selection-row">
                  <div className="vertical-dropdown-container">
                    <div className="vehicle-type-buttons specific-vehicle-type">
                      <button className="vehicle-type-button active" style={{ cursor: 'not-allowed', opacity: 0.6 }}>
                        Bike
                      </button>
                    </div>

                    {/* Brand selection */}
                    <div className="vehicle-dropdown" onMouseEnter={() => this.handleMouseEnter('brand')} onMouseLeave={() => this.handleMouseLeave('brand')}>
                      <div className="dropdown-label" onClick={() => this.setState({ brandDropdownOpen: !this.state.brandDropdownOpen })}>
                        {brand ? (
                          <div className="selected-option">
                            {brand.logo && (
                              <img src={brand.logo} alt={`${brand.label} brand logo`} className="brand-image selected-image" />
                            )}
                            <span>{brand.label}</span>
                          </div>
                        ) : 'Select Brand'}
                        <div className="arrow-down"></div>
                      </div>
                      {this.state.brandDropdownOpen && (
                        <div className="dropdown-options" onMouseEnter={this.handleDropdownOptionsMouseEnter} onMouseLeave={this.handleDropdownOptionsMouseLeave}>
                          {this.state.filteredBikeBrands.map((b, index) => (
                            <div className="option-item" key={index} onClick={() => { this.handleBrandChange(b); this.setState({ brandDropdownOpen: false }); }}>
                              <div className="brand-option">
                                {b.logo && <img src={b.logo} alt={`${b.label} brand logo`} className="brand-image" />}
                                {b.label}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    {/* Model selection */}
                    {brand && (
                      <div className="vehicle-dropdown" onMouseEnter={() => this.handleMouseEnter('model')} onMouseLeave={() => this.handleMouseLeave('model')}>
                        <div className="dropdown-label" onClick={() => this.setState({ modelDropdownOpen: !this.state.modelDropdownOpen })}>
                          {model ? model.label : 'Select Model'}
                          <div className="arrow-down"></div>
                        </div>
                        {this.state.modelDropdownOpen && (
                          <div className="dropdown-options" onMouseEnter={this.handleDropdownOptionsMouseEnter} onMouseLeave={this.handleDropdownOptionsMouseLeave}>
                            {bikeModels.map((m, index) => (
                              <div className="option-item" key={index} onClick={() => { this.handleDropdownClick('model', m); this.setState({ modelDropdownOpen: false }); }}>
                                {m.label}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}

                    {/* CC Range selection */}
                    {brand && model && (
                      <div className="vehicle-type-buttons cc-range-buttons">
                        <div className="cc-range-button-group">
                          {ccRangesToShow.map((ccVal) => (
                            <button key={ccVal} className={`vehicle-type-button cc-range-button ${ccRange === ccVal ? 'active' : ''}`} onClick={() => this.handleDropdownClick('ccRange', ccVal)}>
                              {ccVal}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>

                  {model && model.imagePath && (
                    <div className="vehicle-image-container">
                      <img src={model.imagePath} alt={`${vehicleType} ${model.label}`} />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {this.shouldDisplayServices() && (
            <ServicesSection
              isMobileBrowser={isMobileBrowser}
              isMobileApp={isMobileApp}
              vehicleType={vehicleType}
              model={model}
              brand={brand}
              fuelType={''}
              transmission={''}
              ccRange={ccRange}
              servicesData={currentServices}
              user={user}
              setUser={setUser}
              openModal={openModal}
            />
          )}

          <ChooseUsSection isMobileBrowser={isMobileBrowser} isMobileApp={isMobileApp} />
        </div>

        <Footer isMobileBrowser={isMobileBrowser} isMobileApp={isMobileApp} setCitiesModal={this.props.setCitiesModal} />
      </>
    );
  }
}

export default ZomatoRiderServices;
